/**
 * Stable public URLs for Home LCP / early media.
 * Kept outside hashed Vite assets so index.html can preload them
 * and SSG HTML can discover them before JS runs.
 */
export const FAIR_HOME_HERO_BG_URL = '/home/hero-bg.webp'
export const FAIR_HOME_BANNER_BG_URL = '/home/banner-bg.webp'
export const FAIR_HOME_SEARCH_TUTORIAL_EN_URL = '/home/search-tutorial-en.mp4'
export const FAIR_HOME_SEARCH_TUTORIAL_RU_URL = '/home/search-tutorial-ru.mp4'
